"use client";

import { useState, useEffect } from "@/utils/hooks/reactUseCustomHooks";

interface AdSlotProps {
  id: string;
  width?: string;
  height?: string;
  slotId?: string;
  Fallback?: any;
  className?: string;
}

const AdSlot: React.FC<AdSlotProps> = ({
  id,
  width,
  height,
  Fallback,
  className = "",
}) => {
  const [adLoaded, setAdLoaded] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && (window as any).googletag) {
      try {
        const googletag = (window as any).googletag || { cmd: [] };

        googletag?.cmd.push(() => {
          // Register the slotRenderEnded event listener
          googletag
            .pubads()
            .addEventListener("slotRenderEnded", (event: any) => {
              if (event.slot.getSlotElementId() === id) {
                handleAdRender(event);
              }
            });

          // Trigger the ad load
          if (id) {
            googletag?.display(id);
          }
        });
        return () => {
          googletag?.cmd.push(() => {
            googletag
              .pubads()
              .removeEventListener("slotRenderEnded", handleAdRender);
          });
        };
      } catch (err) {
        console.log(err);
      }
    }
  }, [id]);

  const handleAdRender = (event: any) => {
    setAdLoaded(!event.isEmpty);
  };

  return (
    <>
      {/* Ad Slot */}

      <div
        id={id}
        aria-label="Promtoions"
        className={adLoaded ? className + " overflow-hidden" : ""}
        style={{
          display: !adLoaded ? "none" : "",
          minWidth: width,
          minHeight: height,
        }}
      ></div>

      {/* Fallback */}
      {!adLoaded && <>{Fallback ?? <></>}</>}
    </>
  );
};

export default AdSlot;
